import gql from 'graphql-tag'

const platformList = gql`
  query {
    platformList {
      id
      name
      component
      logo
    }
  }
`

export default platformList
